const { BaseStorage } = require("@/storage/BaseStorage");

const storageKey = "of-ecletica-config";

const eventKey = `${storageKey}:changed`;

export class EcleticaTableConfiguration {
  /**
   *
   * @param {Object} options - Opções de configuração
   * @param {string} options.externalId - Id da mesa da Ecletica
   * @param {string} options.apiUrl - URL da API da Ecletica
   * @param {string} options.apiToken - Token da API da Ecletica
   * @param {string} options.network - Network da API da Ecletica
   * @param {string} options.store - Loja da API da Ecletica
   * @param {BaseStorage} options.storage - Instancia do serviço de armazenamento
   */

  constructor({ externalId, apiUrl, apiToken, network, store, storage }) {
    /**
     * Id da mesa da Ecletica.
     * @type {string}
     */
    this.externalId = externalId;

    /**
     * URL da API da Ecletica.
     * @type {string}
     */
    this.apiUrl = apiUrl;

    /**
     * Token da API da Ecletica.
     * @type {string}
     */
    this.apiToken = apiToken;

    /**
     * Network da API da Ecletica.
     * @type {string}
     */
    // this.network = network;

    /**
     * Loja da API da Ecletica.
     * @type {string}
     */
    // this.store = store;

    /**
     * Instancia do serviço de armazenamento.
     * @type {BaseStorage}
     */
    this.storage = storage;
  }

  static fromStorage() {
    const storage = new BaseStorage({ key: storageKey });

    const configs = storage.getData();

    const tableConfiguration = new EcleticaTableConfiguration({
      ...configs,
      storage,
    });

    tableConfiguration.updateStatus();

    return tableConfiguration;
  }

  update(configs) {
    this.externalId = configs?.externalId || this.externalId;
    this.apiUrl = configs?.apiUrl || this.apiUrl;
    this.apiToken = configs?.apiToken || this.apiToken;
    // this.network = configs?.network || this.network;
    // this.store = configs?.store || this.store;

    this.updateStatus();

    if (window) {
      this.storage.setData(this);

      window.dispatchEvent(
        new CustomEvent(eventKey, {
          detail: { storage: this.storage.id, key: this.storage.getKey() },
        })
      );
    }
  }

  addListener(handler) {
    if (!this.listener) {
      this.listener = (event) => {
        if (event.detail.key === this.storage.getKey()) {
          handler();
        }
      };
      window.addEventListener(eventKey, this.listener);
    }
  }

  removeListener() {
    if (this.listener) {
      window.removeEventListener(eventKey, this.listener);
      this.listener = null;
    }
  }

  export() {
    const { storage, listener, ...configs } = this;
    return { ...configs };
  }

  isConfigured() {
    return !!(this.externalId && this.apiUrl && this.apiToken);
  }


  updateStatus() {
    this.configured = this.isConfigured();
  }
}
